import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { customerInfoListColumn, customerInfoListData } from "./CustomerInfoHelper";
import StlapFooter from "../../CustomComponents/StlapFooter";
import { useDispatch } from "react-redux";
import { SpinnerReduerAction } from "../../Store/spinner/SpinnerReducer";
import CustomSpinner from "../../CustomComponents/CustomSpinner";

const CustomerInfoList = () => {

  const dispatch = useDispatch();

  const [columnData, setColumnData] = useState([]);

  useEffect(() => {
    loadCustomerInfoList();
  }, []);

  const loadCustomerInfoList = async() => {
    dispatch(SpinnerReduerAction.updateSpinnerFlag(true));
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL =
      process.env.REACT_APP_STLAP_LOS_DATA_BACKEND;
      const response = await newAxiosBase.post("/stlap/getCustomerInformation");
      customerInfoListData(response.data).then(v => setColumnData(v));
      dispatch(SpinnerReduerAction.updateSpinnerFlag(false));
  }
  
    return(
        <>
        <CustomSpinner />
         <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Customer Information List"
          initialOpen={true}
        >
        <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={columnData}
            columns={customerInfoListColumn}
            pageSize={15}
            pageSizeOptions={[20]}
            gridLazyLoad={() => {}}
            gridHeight={500}
            getRowId={(row) => row.internalCustomerId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
          </Box>
          <StlapFooter />
          </>
    );
}

export default CustomerInfoList;